//component
import CartForm from "./components/cart.form";
import CartBasic from "./components/cart.basic";
import Pusher from "pusher-js";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCartInfo } from "../../redux/reducer/cart.reducer";
import {
  closeFullLoading,
  getCartCount,
} from "../../redux/reducer/common.reducer";
import { useNavigate } from "react-router-dom";
import CommonNotFound from "../../components/common/common.not.found";

export default function Cart() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { cartInfo, cartInfoLoading } = useSelector((state) => state.cart);
  const { token, userId, username, cartCount } = useSelector(
    (state) => state.common
  );

  useEffect(() => {
    dispatch(getCartInfo());
  }, []);

  useEffect(() => {
    if (!cartInfo.items && cartCount > 0) {
      dispatch(getCartCount());
    }
  }, []);

  //call order paid socket
  useEffect(() => {
    if (token && userId && username) {
      const pusher = new Pusher(process.env.REACT_APP_SOCKET_API_KEY, {
        cluster: "ap1",
        authEndpoint: process.env.REACT_APP_SOCKET_API_URL,
        auth: {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            username: username === "null" ? null : username,
          },
        },
      });

      const channel = pusher.subscribe("presence-user" + userId);

      let socketId = null;
      pusher.connection.bind("connected", () => {
        socketId = pusher.connection.socket_id;
      });

      channel.bind("order-paid-event", (data) => {
        if (data) {
          dispatch(closeFullLoading());

          if (data.data.payment_status && data.data.order_id) {
            if (
              data.data.payment_status !== null &&
              data.data.order_id !== null
            ) {
              navigate(
                `/order?status=${data.data.payment_status}&order_id=${data.data.order_id}`
              );
            }
          }
        }
      });

      return () => {
        channel.unbind("order-paid-event");
        pusher.disconnect();
      };
    }
  }, [token, userId, username]);

  return (
    <article className="cart">
      {cartInfoLoading ||
      (!cartInfoLoading && cartCount > 0 && cartInfo.items?.length > 0) ? (
        <>
          <CartForm />
          <CartBasic />
        </>
      ) : (
        <CommonNotFound
          title="Your Cart is Empty"
          message="Looks like you haven't added anything yet. Start shopping now!"
        />
      )}
    </article>
  );
}
